import { SHOW_CUSTOMERS_FOR } from '@src/constants'
import { useMemo } from 'react'
import useGetAccount from './useGetAccount'

export const useGetShowCustomers = () => {
  const account = useGetAccount()

  return useMemo(() => {
    const teams =
      SHOW_CUSTOMERS_FOR?.split(',')
        ?.map((id: string) => id?.trim())
        .filter(Boolean) || []

    if (!teams.length) {
      return true
    }
    if (account?.team) {
      return teams.includes(account?.team?.id?.toString())
    }

    return false
  }, [account])
}
